export const ORGANIZATIONS_API_URL = 'ui/partner/organizations';

export const organizationsQueryKeys = {
  all: [ORGANIZATIONS_API_URL],
};
